/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Comparison from './Comparison/index'
import Gallery from './Gallery/index'
import Images from './Images/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content"
  
}) {
  return (<React.Fragment
>
<Images
  viewPath={`${viewPath}/Images`}
/>
<Gallery
  viewPath={`${viewPath}/Gallery`}
/>
<Comparison
  viewPath={`${viewPath}/Comparison`}
/>
{children}
</React.Fragment>)
}